import { useState } from "react";
import "./ForgotPassword.css";

const API_HOST = process.env.REACT_APP_API || "https://api.lucianacosta.cv";
const API = `${API_HOST}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sub, setSub] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    if (sub) return;
    setMsg(""); setErr("");
    setSub(true);

    try {
      const r = await fetch(`${API}/auth/forgot`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || "Não foi possível enviar as instruções.");
      setMsg("Se o email existir, enviámos instruções para redefinir a password.");
      setEmail("");
    } catch (e) {
      setErr(/Failed to fetch/i.test(String(e?.message))
        ? "Falha de ligação à API (CORS ou rede)."
        : e.message);
    } finally {
      setSub(false);
    }
  }

  return (
    <div className="auth-page py-4">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-7 col-xl-5">
            <h1 className="auth-title h2 mb-3">Recuperar password</h1>

            {msg && <div className="alert alert-success">{msg}</div>}
            {err && <div className="alert alert-danger">{err}</div>}

            <div className="auth-card p-4 p-md-4">
              <form onSubmit={onSubmit} noValidate>
                <div className="mb-4">
                  <label className="form-label">Email</label>
                  <input
                    className="form-control"
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                    placeholder="exemplo@dominio.cv"
                    autoComplete="email"
                  />
                </div>

                <button className="btn btn-primary w-100" disabled={sub}>
                  {sub ? "A enviar…" : "Enviar instruções"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
